import { MenuItem, Divider } from '@mui/material';
import { styled } from '@mui/system';
import Settings from '@mui/icons-material/Settings';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../../store/auth/authSlice';

const UserMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '2px 0',
  [theme.breakpoints.down('sm')]: {
    borderBottom: '1px solid rgba(170, 145, 120, 0.7)',
    height: '40px',
    minHeight: '40px',
  },
}));

const MenuLinkItem = styled('a')(({ theme }) => ({
  fontFamily: 'Raleway',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  color: '#000000',
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '0 20px 0 10px',

  '& svg': {
    fontSize: 18,
    color: 'rgba(0, 0, 0, 0.54)',
    margin: '6px 14px 6px 10px',
    [theme.breakpoints.down('sm')]: {
      marginRight: '12px',
      fontSize: 16,
    },
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '16px',
  },
}));

const UserMenuContainer = styled('ul')({
  margin: '0',
  padding: '0',
});

const UserMenuItems = (props) => {
  const currentUserId = useSelector(selectUser);

  return (
    <UserMenuContainer>
      <UserMenuItem>
        <MenuLinkItem href={`/user/${currentUserId}`}>
          <AccountCircleIcon />
          Profile
        </MenuLinkItem>
      </UserMenuItem>
      <UserMenuItem>
        <MenuLinkItem href="/user/setting">
          <Settings />
          Setting
        </MenuLinkItem>
      </UserMenuItem>
      <UserMenuItem>
        <MenuLinkItem href="#">
          <PeopleAltIcon />
          Following
        </MenuLinkItem>
      </UserMenuItem>
      <Divider sx={{ display: { xs: 'none', sm: 'block' } }} />
      <UserMenuItem onClick={props.handleLogOut}>
        <MenuLinkItem href="#">
          <MeetingRoomIcon />
          Logout
        </MenuLinkItem>
      </UserMenuItem>
    </UserMenuContainer>
  );
};
export default UserMenuItems;
